<script>
	import { scaleAdOnHover, startAd } from '../../../../share/ads';
	import { getText } from '../../../../share/utils';

	let ads = {
		// WIKANA-0036-Unterwegs-mit-Keks-3oo_x_25o-ovk
		wikanaMRec: {
			element: false,
			fallbackImgUrl: './../commercial/10.Appetit_Digitalisieren/03.appetit_digitalisieren/WIKANA-3oo_x_25o/backup.webp',
			imageAltText: 'Wikana - Unterwegs-mit-Keks - interactive Ad',
			iframeIndexUrl: './../commercial/10.Appetit_Digitalisieren/03.appetit_digitalisieren/WIKANA-3oo_x_25o/index.html',
			playTimeMs: 32000,
			maxScale: 1,
			playing: false,
			autoStopTimeOut: false
		},
		// WIKANA-0036-Unterwegs-mit-Keks-770x250-adform
		wikanaBillboard: {
			element: false,
			fallbackImgUrl: './../commercial/10.Appetit_Digitalisieren/03.appetit_digitalisieren/WIKANA-770x250/backup.webp',
			imageAltText: 'Wikana - Unterwegs-mit-Keks - interactive Ad',
			iframeIndexUrl: './../commercial/10.Appetit_Digitalisieren/03.appetit_digitalisieren/WIKANA-770x250/index.html',
			// playTimeMs: 32000,
			playTimeMs: 12332000,
			playing: false,
			autoStopTimeOut: false,
			scale: 1,
			origWidth: 770,
			origHeight: 250
		},
		// WIKANA-0036-Unterwegs-mit-Keks-120x600-ovk
		wikanaSkyscraper: {
			element: false,
			fallbackImgUrl: './../commercial/10.Appetit_Digitalisieren/03.appetit_digitalisieren/WIKANA-120x600/backup.webp',
			imageAltText: 'Wikana - Unterwegs-mit-Keks - interactive Ad',
			iframeIndexUrl: './../commercial/10.Appetit_Digitalisieren/03.appetit_digitalisieren/WIKANA-120x600/index.html',
			playTimeMs: 32000,
			maxScale: 1,
			playing: false,
			autoStopTimeOut: false
		}
	}
</script>

<div>
	<div class="flex structure marginbox">
		<div class="flex structure-1">
			<div class="flex element billboard">
				<!-- Beginning - Ad: wikanaBillboard -->
				<div bind:this={ads.wikanaBillboard.element} class="content"
					 style="
					 --scale: {ads.wikanaBillboard.scale};
					 --origWidth: {ads.wikanaBillboard.origWidth || 0}px;
					 --origHeight: {ads.wikanaBillboard.origHeight || 0}px;
				">
						<div class="commercial scale_inner_container" class:playing={ads.wikanaBillboard.playing} on:click={() => startAd(ads.wikanaBillboard, () => ads = ads)}>
							<!-- PLAYING -->
							<img loading="lazy" alt="Website-Screenshot"
								 src="./../img/10.Appetit_Digitalisieren/03.appetit_digitalisieren/website.webp">
					{#if ads.wikanaBillboard.playing}
							<div class="container-overlay">
								<img loading="lazy" alt={ads.wikanaBillboard.imageAltText} src={ads.wikanaBillboard.fallbackImgUrl}/>
								<iframe class="scaled-iframe" scrolling="no" src={ads.wikanaBillboard.iframeIndexUrl}
										style="--bg-image: url('{ads.wikanaBillboard.fallbackImgUrl}')"
										on:load={(e) => e.target.setAttribute('loaded', 'true')}/>
							</div>
					{:else}
							<div use:scaleAdOnHover class="container-overlay">
								<img loading="lazy" alt={ads.wikanaBillboard.imageAltText} src={ads.wikanaBillboard.fallbackImgUrl}/>
								<button aria-label="play Ad - {ads.wikanaBillboard.imageAltText}" class="playbutton"></button>
							</div>
					{/if}
						</div>
				</div>
				<!-- End - Ad -->
			</div>
		</div>
		<div class="flex row structure-2">
			<div class="flex col structure-2-1">
				<div class="flex element mrec">
					<!-- Beginning - Ad: wikanaMRec -->
					<div bind:this={ads.wikanaMRec.element} class="content">
						{#if ads.wikanaMRec.playing}
							<div class="commercial" class:playing={ads.wikanaMRec.playing}>
								<!-- PLAYING -->
								<iframe scrolling="no" src={ads.wikanaMRec.iframeIndexUrl}
										style="--bg-image: url('{ads.wikanaMRec.fallbackImgUrl}')"
										on:load={(e) => e.target.setAttribute('loaded', 'true')}/>
							</div>
						{:else}
							<div use:scaleAdOnHover class="commercial" class:playing={ads.wikanaMRec.playing} on:click={() => startAd(ads.wikanaMRec, () => ads = ads)}>
								<!-- NOT PLAYING -->
								<img loading="lazy" alt={ads.wikanaMRec.imageAltText} src={ads.wikanaMRec.fallbackImgUrl}/>
								<button aria-label="play Ad - {ads.wikanaMRec.imageAltText}" class="playbutton"></button>
							</div>
						{/if}
					</div>
					<!-- End - Ad -->
				</div>
				<div class="flex element mrec">
					<div class="content">
						<img loading="lazy" alt="Wikana-Werbemittel Medium Rectangle"
							 src="./../commercial/10.Appetit_Digitalisieren/03.appetit_digitalisieren/WIKANA-3oo_x_25o/backup_2.webp">
					</div>
				</div>
			</div>
			<div class="flex col structure-2-2">
				<div class="flex element sky">
					<!-- Beginning - Ad: wikanaSkyscraper -->
					<div bind:this={ads.wikanaSkyscraper.element} class="content">
						{#if ads.wikanaSkyscraper.playing}
							<div class="commercial" class:playing={ads.wikanaSkyscraper.playing}>
								<!-- PLAYING -->
								<iframe scrolling="no" src={ads.wikanaSkyscraper.iframeIndexUrl}
										style="--bg-image: url('{ads.wikanaSkyscraper.fallbackImgUrl}')"
										on:load={(e) => e.target.setAttribute('loaded', 'true')}/>
							</div>
						{:else}
							<div use:scaleAdOnHover class="commercial" class:playing={ads.wikanaSkyscraper.playing} on:click={() => startAd(ads.wikanaSkyscraper, () => ads = ads)}>
								<!-- NOT PLAYING -->
								<img loading="lazy" alt={ads.wikanaSkyscraper.imageAltText} src={ads.wikanaSkyscraper.fallbackImgUrl}/>
								<button aria-label="play Ad - {ads.wikanaSkyscraper.imageAltText}" class="playbutton"></button>
							</div>
						{/if}
					</div>
					<!-- End - Ad -->
				</div>
			</div>
			<div class="flex structure-2-3">
				<div class="flex element">
					<div class="content row">
						<h2 class="caption">{getText("10.03.01_h2")}</h2>
						<p class="caption">{getText("10.03.02_caption")}</p>
						<p class="caption blue">Project Lead: <a href="//www.zebra.de" target="_blank">Zebra</a></p>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<style lang="scss">
	@import "../../../../style/mixins";
	@import "../../../../style/variables";
	
	.commercial {
		position: relative;
		
		width: 100%;
		height: 100%;
		line-height: 0;
	}
	
	.billboard iframe,
	.mrec iframe,
	.sky iframe {
		width: 100%;
		height: 100%;
	}

	iframe {
		border: none;
		background-image: var(--bg-image);
		background-size: cover;
	}

	:global(iframe[loaded]) {
		background-image: none !important;
	}

	.billboard iframe {
		position: absolute;
		left: 0;
	}

	.flex {
		display: flex;
		box-sizing: border-box;
	}
	
	.row {
		flex-flow: row wrap;
	}
	
	.col {
		flex-flow: column wrap;
	}
	
	.element {
		min-width: 100px;
		align-self: center;
	}
	
	.content {
		flex: 1 100%;
	}
	
	.structure {
		flex-flow: column;
		
		@include for-desktop-up {
			flex-flow: row nowrap;
		}
	}
	
	.structure-1 {
		flex-shrink: 1;
		width: auto;
		margin-bottom: $media-gap;
		flex: 2;

		@include for-tablet-landscape-up {
			margin-top: 0;
			margin: 0 $media-gap $media-gap 0;
		}
		@include for-big-desktop-up {
			flex: 3;
		}

		.element {
			align-self: start;
		}
	}
	
	.structure-2 {
		width: 100%;
		justify-content: space-evenly;
		margin: 0 0 $spacing-mobile 0; // no left or right margin because ads would be cut on tiny screens
		flex: 2;
		
		@include for-tablet-portrait-up {
			justify-content: center;
			margin: 0 auto $spacing-mobile auto;
		}
		
		@include for-desktop-up {
			justify-content: flex-start;
		}
	}
	
	.structure-2-3 {
		margin: $spacing-mobile $spacing-mobile 0 $spacing-mobile;
		max-width: calc(300px + 120px);
		
		@include for-tablet-landscape-up {
			margin: 0 $media-gap 0 $spacing-mobile;

			.element {
				align-self: end;
			}
		}
	}
	
	.mrec {
		width: 100%;
		max-width: 300px;
		height: 250px; // without fixed height the container will be too short when ad is playing
		margin: 0 0 $media-gap 0;

		&.hide_mobile {
			display: none;

			@include for-big-desktop-up {
				display: block;
			}
		}

		@include for-tablet-portrait-up {
			margin: 0 $media-gap $media-gap 0;
		}
	}
	
	.sky {
		width: 120px;
		height: 600px;
	}
	
	img {
		width: 100%;
		margin: 0;
		padding: 0;
	}
	
	h3 {
		margin-bottom: $media-gap;
	}
	
	p:first-of-type {
		margin-bottom: $media-gap;
	}
	
	.billboard {
		flex-grow: 1;
		
		.commercial {
			overflow: hidden;
		}
		
		.container-overlay {
			position: absolute;
			width: 65%;
			height: auto;
			top: 18.5%;
			left: 17.5%;
		}

		// class scaled-iframe is for ads sitting on a background image
		.scaled-iframe {
			border: 0;
			
			zoom: 1;
			transform: scale(1);
			transform-origin: 0 0;
			position: absolute;
			left: 0;
			top: 0;

			// 0.8 as equivalent to 80% (see above)
			scale: calc(var(--scale) * 0.65) !important;
			height: calc(var(--origHeight)) !important;
			width: calc(var(--origWidth)) !important;
		}
	}
</style>
